<template>
  <!-- 时间轴视图 -->
  <div class="timeview">
    <div class="navs">
      <div class="lt">
        <img src="../../assets/img/home/center/whole.png" alt="" />
        <div class="nav-lt-tit">时间轴视图</div>
      </div>
      <div class="rt">
        <div class="time" @click="selectPopup = !selectPopup">
          <span>{{ selectTodoTime }}</span>
          <i
            :class="selectPopup ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
          ></i>
        </div>
      </div>
    </div>

    <div class="select-popup" v-show="selectPopup">
      <div
        :class="{ 'text-active': selectIndex == -1 }"
        @click="selectTimeval('全部', -1)"
      >
        全部
      </div>
      <div
        v-for="(item, index) in selectTodoTimeArray"
        :key="index"
        @click="selectTimeval(item, index)"
        :class="{ 'text-active': selectIndex == index }"
      >
        {{ item }}
      </div>
    </div>

    <div class="main" @scroll="onScroll">
      <div class="mains" v-for="(item, index) in todoArray" :key="index">
        <div class="haed">
          <div class="lt">
            <span
              >{{ item.date.split(".")[1] }}月{{
                item.date.split(".")[2]
              }}日</span
            >
            <span>{{ item.date.split(".")[0] }}年</span>
          </div>
        </div>
        <div class="box" v-for="(item1, index1) in item.info" :key="index1">
          <div class="lt">
            <div class="dian">
              <div></div>
            </div>
            <div class="sj">
              {{ item1.time }}
            </div>
          </div>
          <div class="info">
            {{ item1.task_name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import dateFunc from "../../util/dateFunc";
import leftNav from "../../components/content/leftNav";

export default {
  data() {
    return {
      selectTodoTime: "",
      selectTodoTimeArray: [],
      selectPopup: false,
      selectIndex: -1,
      todoArray: [],

      nowDate: "", // 当前日期
      mdData: "",
      todoData: [],
      selectTime: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },

      activeStep: null,
    };
  },
  methods: {
    changeDate(e) {
      console.log(e, "选择的时间");
      let val = this.chaneIndex();
      console.log(val, "111111");
      setTimeout(() => {
        this.jump(val);
      }, 500);
    },

    changeTime() {
      console.log(this.$refs.datepicker, "时间选择器");
      this.$refs.datepicker.showPicker();
    },

    jump(index) {
      // .subject-list-wrap-relot-const 必须和你在页面中取的一致
      let items = document.querySelectorAll(".mains");
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].scrollIntoView({
            block: "start", //默认跳转到顶部
            behavior: "smooth", //滚动的速度
          });
        }
      }
    },

    onScroll(e) {
      // console.log(e);
      // let scrollItems = document.querySelectorAll(".mains");
      // for (let i = scrollItems.length - 1; i >= 0; i--) {
      //   // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
      //   let judge =
      //     e.target.scrollTop >=
      //     scrollItems[i].offsetTop - scrollItems[0].offsetTop;
      //   if (judge) {
      //     this.activeStep = i;
      //     break;
      //   }
      // }
    },

    chaneIndex() {
      let val = null;
      let newtime = new Date(this.mdData).getTime();
      for (let i = 0; i < this.todoData.length; i++) {
        if (this.todoData[i].taskIndex == newtime) {
          console.log(this.todoData[i].task_time, this.mdData, "时间");
          val = i;
        }
      }
      console.log(val, "2222222");
      if (!val) {
        this.$message.warning("当前日期未添加待办事件！");
        return this.todoData.length - 1;
      } else {
        return val;
      }
    },

    selectTimeval(item, index) {
      this.selectTodoTime = item;
      this.selectIndex = index;
      this.selectPopup = false;
      this.todoArray = [];
      if (item == "全部") {
        this.queryAllData();
      } else {
        this.queryTodoData();
      }
    },

    queryTodo() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api.selecttime("", header).then(
        (res) => {
          console.log(res, "查询的所有时间段");
          let data = res.data.result;
          if (data.length) {
            this.selectTodoTime = data[0];
            this.selectIndex = 0;
            this.selectTodoTimeArray = data;
            this.queryTodoData();
          }
        },
        (err) => {}
      );
    },

    queryAllData() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .alltodo("", header)
        .then((res) => {
          console.log(res, "全部待办清单");
          let data = res.data.result;
          let data1 = [...data.future, ...data.past_due, ...data.today];
          this.todoArray = this.changeAlldata(data1);
          console.log(this.changeAlldata(data1), "合并的全部数据");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    queryTodoData() {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      let selectyear = "";
      if (this.selectTodoTime != "全部") {
        selectyear = this.selectTodoTime;
      }
      this.$api
        .timeaxis(selectyear, header)
        .then((res) => {
          console.log(res, "全部待办清单");
          let data = res.data.result[0];
          this.todoArray = data[this.selectTodoTime.split('-')[0]];
          console.log(this.todoArray, "处理的数据12312312312312312");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeAlldata(_list) {
      let newArr = [];
      _list.forEach((item, i) => {
        item.time =  `${item.create_time.split("T")[1].split(":")[0]} : ${item.create_time.split("T")[1].split(":")[1]}`
              
        let index = -1;
        let isExists = newArr.some((newItem, j) => {
          if (item.task_time == newItem.date1) {
            index = j;
            return true;
          }
        });
        if (!isExists) {
          newArr.push({
            date: item.task_time.split('-').join('.'),
            date1: item.task_time,
            taskIndex: new Date(item.task_time).getTime(),
            info: [item],
          });
        } else {
          newArr[index].info.push(item);
        }
      });
      newArr.sort((a, b) => {
        return a.taskIndex - b.taskIndex;
      });
      return newArr;
    },

    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
      this.mdData = `${year}-${month}-${day}`;
      this.queryTodo();
    },
  },
  created() {
    this.formatDate();
  },
  // 销毁定时器
  beforeDestroy() {},
};
</script>>

<style lang="scss" acoped>
.timeview {
  width: 100%;
  height: 100%;
  background-color: var(--color-theme);
  padding-top: 50px;
  box-sizing: border-box;
  position: relative;
}

.navs {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 53px;

  .lt {
    display: flex;
    align-items: center;
    img {
      width: 26px;
      height: 22px;
      margin-right: 35px;
    }

    div {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }
  }

  .rt {
    overflow: hidden;
    display: flex;

    .time {
      width: 100px;
      height: 35px;
      background-color: rgba(0, 166, 138, 0.12);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #333333;
      cursor: pointer;
    }
  }
}

.select-popup {
  width: 100px;
  max-height: 500px;
  overflow-y: scroll;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.08);
  font-size: 18px;
  color: #333333;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 90px;
  right: 20px;
  transition: all 0.3s;

  div {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #c2c2c2;
  }

  div:last-child {
    border-bottom: none;
  }

  .text-active,
  div:hover {
    color: #00ad90;
    cursor: pointer;
  }
}

.main {
  width: 100%;
  height: calc(100% - 143px);
  overflow: auto;
  .mains {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: auto;
    .haed {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;

      .lt {
        span:nth-child(1) {
          font-size: 26px;
          font-weight: bold;
        }
        span:nth-child(2) {
          margin-left: 25px;
          font-size: 18px;
          color: #999999;
        }
      }
    }
    .box {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .lt {
        display: flex;
        align-items: center;
        margin-right: 40px;

        .dian {
          width: 27px;
          height: 27px;
          border: solid 1px #dcdcdc;
          border-radius: 50%;
          display: flex;
          align-items: center;
          margin-right: 33px;

          div {
            width: 13px;
            height: 13px;
            background-color: #4b6ffe;
            line-height: 27px;
            margin: auto;
            border-radius: 50%;
          }
        }

        .sj {
          font-size: 18px;
          color: #999999;
        }
      }

      .info {
        flex: 1;
        height: 66px;
        background-color: #ffffff;
        border-radius: 9px;
        line-height: 66px;
        padding: 0 22px;
        box-sizing: border-box;
        font-size: 22px;
        color: #333333;
      }
    }
  }
}
.main::-webkit-scrollbar {
  width: 3px;
}
.main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}

.select-popup::-webkit-scrollbar {
  width: 3px;
}
.select-popup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
</style>